import { Dialog, CircularProgress } from "@material-ui/core";
import CancelOutlinedIcon from "@material-ui/icons/CancelOutlined";
import paymentConstants from "../../constants/payments.constants";
import cssStyles from "./refundModal.module.css";

// Sin cobro no hay reembolso: una orden presencial que todavia no se cobro se
// rechaza y listo. Antes el modal prometia un "reintegro automatico desde su
// cuenta cash" que no existe, y el backend mandaba el correo de devolucion.
const isUncollectedPresential = (order) =>
  paymentConstants.PRESENTIAL.includes(order?.payment) && !order?.paymentId;

function RefundDialog({
  handleClose,
  open,
  handleAccept,
  orderNumber,
  fullName,
  operationId,
  paymentMethod,
  loading,
  order,
  total,
}) {
  const sinCobro = isUncollectedPresential(order ?? { payment: paymentMethod });
  const methodName =
    paymentConstants.TYPES_NAMES[paymentMethod] ?? paymentMethod ?? "No definido";

  const formatAmount = (value) =>
    new Intl.NumberFormat("es-CL").format(Number(value ?? 0));

  return (
    <Dialog
      open={open}
      onClose={loading ? undefined : handleClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{ className: cssStyles.paper }}
    >
      <div className={cssStyles.header}>
        <span className={cssStyles.headerIcon}>
          <CancelOutlinedIcon fontSize="small" />
        </span>
        <div className={cssStyles.headerText}>
          <p className={cssStyles.title}>Rechazar pedido</p>
          <p className={cssStyles.subtitle}>Esta accion no se puede deshacer</p>
        </div>
      </div>

      <div className={cssStyles.body}>
        <div className={cssStyles.orderBox}>
          <div>
            <p className={cssStyles.orderLabel}>Pedido</p>
            <p className={cssStyles.orderValue}>
              N&deg; {orderNumber}
              {total ? ` \u00b7 $${formatAmount(total)}` : ""}
            </p>
            <p className={cssStyles.customer}>{fullName}</p>
          </div>
          <span className={cssStyles.methodChip}>{methodName}</span>
        </div>

        {sinCobro ? (
          <p className={`${cssStyles.note} ${cssStyles.noteInfo}`}>
            <strong>El pedido no fue cobrado.</strong> No hay devolucion que
            hacer: se cancela y se le avisa al cliente.
          </p>
        ) : (
          <>
            <p className={`${cssStyles.note} ${cssStyles.noteRefund}`}>
              Se hara el reintegro automatico a {methodName} y se le notificara
              al cliente.
              {operationId ? ` Transaccion ${operationId}.` : ""}
            </p>

            {paymentMethod === "mercadopago" && (
              <p className={`${cssStyles.note} ${cssStyles.noteWarning}`}>
                Tenes 48 horas para hacer el reembolso automatico por este
                medio. Pasado ese plazo hay que hacerlo a mano.
              </p>
            )}
            {paymentMethod === "getnet" && (
              <p className={`${cssStyles.note} ${cssStyles.noteWarning}`}>
                Tenes 24 horas para hacer el reembolso automatico por este
                medio. Pasado ese plazo hay que hacerlo a mano.
              </p>
            )}
          </>
        )}
      </div>

      <div className={cssStyles.footer}>
        <button
          type="button"
          className={cssStyles.cancelBtn}
          onClick={handleClose}
          disabled={loading}
        >
          Cancelar
        </button>
        <button
          type="button"
          className={cssStyles.confirmBtn}
          onClick={handleAccept}
          disabled={loading}
        >
          {loading ? (
            <CircularProgress style={{ color: "#fff", height: 20, width: 20 }} />
          ) : sinCobro ? (
            "Rechazar pedido"
          ) : (
            "Rechazar y devolver"
          )}
        </button>
      </div>
    </Dialog>
  );
}

export default RefundDialog;
